/* #### UIAccordeon.js ####
 * Dependencies:
 * - jQuery
 * - UIElement
 */

var UIElement = require('./UIElement');
var $ = require('jquery');
require('../../plugins/jquery.tap');

function UIAccordeon(options) {
  UIElement.call(this, options);
  var $element = this.$el,
    $lastItemActive = $element.children('.ui-item.ui-active');
  $element.on('tap.uiaccordeon', ".ui-caption", function(e) {
    var $this = $(this),
      $active = $this.parent().hasClass('ui-active');
    e.preventDefault();
    if ($lastItemActive)
      $lastItemActive.removeClass('ui-active').children('.ui-content').show().slideUp('fast');
    $lastItemActive = null;
    if ($active) return false;
    $this.siblings('.ui-content').hide().slideDown('fast');
    $lastItemActive = $this.parent().addClass('ui-active');
  });
}

UIAccordeon.prototype = $.extend(Object.create(UIElement.prototype), {
  constructor: UIAccordeon
});

UIAccordeon.dataSetName = 'UIAccordeon';

$.fn.UIAccordeon = function() {
  return this.each(function() {
    var $el = $(this);
    if (UIElement.hasDataset($el, UIAccordeon))
      return;
    new UIAccordeon({
      el: $el
    }).saveDataset();
  });
};


module.exports = UIAccordeon;
